import React, { useRef, useState } from 'react';
import { message } from 'antd';
import { theme } from 'utils/style/theme';
import DefaultButton from 'components/button/DefaultButton';
import DefaultInput from 'components/input/DefaultInput';
import DefaultModal from 'components/modal/DefaultModal';
import DefaultForm from 'components/form/DefaultForm';
import { IBubbleSet, ICommonCode } from 'utils/types/storyTypes';
import { Select } from 'antd';
import styled from 'styled-components';
import { storyApi } from 'apis/story/storyApis';
import { useTranslation } from 'react-i18next';
import PrimaryButton from 'components/button/PrimaryButton';
import SelectBox from 'components/SelectBox';
import InputStyled from 'components/InputStyled';
import { IAccount } from '../../../utils/types/common';
import { userApi } from '../../../apis/user/userApi';
import { useAppSelector } from '../../../hooks/redux';
import { useParams } from 'react-router-dom';

/**
 * * 작품 관리 - 작품 등록 모달
 */

interface IProjectProp {
  title: string;
  project_type: number;
}

interface IProps {
  visible: boolean;
  setVisible: (e: any) => void;
  organizationUsers: IAccount[];
  setOrganizationUsers: React.Dispatch<any>;
  currentProjectUsers: IAccount[];
  setCurrentProjectUsers: React.Dispatch<any>;
  projectId: number;
}

const ProjectAuthModal = ({
  visible,
  setVisible,
  organizationUsers, // 언어 dropdown 용도
  setOrganizationUsers,
  currentProjectUsers,
  setCurrentProjectUsers,
  projectId,
}: IProps) => {
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.userSlice.userInfor);
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async () => {
    setLoading(true);
    const response = await userApi.changeProjectUsers(
      user!.organization.name,
      projectId,
      currentProjectUsers.map((user) => user.id),
    );
    if (response.isSuccess) {
      message.success('프로젝트 참여자 수정이 완료 되었습니다.', 1); // TODO : i18n 적용
    } else {
      message.error(response.message, 1);
    }

    setLoading(false);
    setVisible(false);
    setCurrentProjectUsers([]);
  };

  const handleClose = () => {
    setLoading(false);
    setVisible(false);
    setCurrentProjectUsers([]);
  };

  const handleChangeUsers = (value: string[]) => {
    const newUsers = organizationUsers.filter((user) =>
      value.includes(user.email),
    );
    setCurrentProjectUsers(newUsers);
  };

  console.log(currentProjectUsers);

  return (
    <DefaultModal
      title={'프로젝트 참여자'}
      visible={visible}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={'저장'}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
          />
        </ButtonWrapper>
      }
    >
      <Wrapper>
        <LangSelectWrapper>
          <p>프로젝트 참여자 변경</p>
          <Select
            size='large'
            mode={'multiple'}
            onChange={handleChangeUsers}
            value={currentProjectUsers.map((user) => user.email)}
            style={{ width: '100%' }}
          >
            {organizationUsers?.map((v) => (
              <Select.Option key={v.id} value={v.email}>
                {v.email}
              </Select.Option>
            ))}
          </Select>
        </LangSelectWrapper>
      </Wrapper>
    </DefaultModal>
  );
};

export default ProjectAuthModal;

const Wrapper = styled.div`
  & > * + * {
    margin-top: 1rem;
  }
`;

const LangSelectWrapper = styled.div`
  margin-bottom: 1rem;
  & > * + * {
    margin-top: 8px;
  }
  p {
    color: ${theme.colors.dark_500};
    font-size: ${theme.fontSizes.sm};
    font-weight: ${theme.fontWeights.normal};
  }
  .tips {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.red_300};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;
